import { useProfile } from './useProfile';
import { useMyProjects } from './useMyProjects';

export const useCurrentProject = () => {
  const profile = useProfile();
  const myProjects = useMyProjects();

  return myProjects.find((project) => project.id === profile.currentProject);
};
